import styled from 'styled-components';

import { SecondaryButton, PrimaryButton } from 'components/Buttons';

// STYLES
import colors from 'styles/colors';
import { BUTTON_BORDER_RADIUS } from 'styles/buttons';
import { HEADER_HEIGHT, SHADOW_BORDER_RULE } from 'styles/common';

/* eslint-disable no-extra-parens */
export const Container = styled.header<{ shadow?: boolean }>`
  border-bottom: 1px solid ${colors.primary};

  ${(props) =>
    props.shadow
      ? `
            padding-left: 21px;
            padding-right: 21px;
            border-bottom: 0;
            background-color: ${colors.white};
            ${SHADOW_BORDER_RULE};
        `
      : null};
`;

export const Content = styled.div`
  height: ${HEADER_HEIGHT};
  display: flex;
  gap: 16px;
  align-items: center;

  & > div:last-child > *:not(:first-child) {
    margin-left: 20px;
  }
`;

export const Title = styled.h1`
  align-items: center;
  color: ${colors.primary};
  display: flex;
  flex-direction: row;
  font-size: 22px;
  font-weight: 600;
  margin: 0;
`;

export const Subtitle = styled.h2`
  font-size: 14px;
  line-height: 19px;
  font-weight: normal;
  color: ${colors.primary};
  margin: 0;
  margin-top: 5px;
`;

export const Middle = styled.div<{ visible?: boolean }>`
  display: ${(props) => (props.visible ? 'inline-block' : 'none')};
  flex-basis: 45%;
  flex-grow: 1;
`;

export const Right = styled.div`
  margin-left: auto;
  min-width: fit-content;

  button {
    min-width: 102px;
  }

  .tab-button {
    min-width: auto;
  }
`;

export const Left = styled.div`
  min-width: fit-content;
`;

export const TabsContainer = styled.div`
  display: inline-block;
`;

export const ActiveTabButton = styled(PrimaryButton)`
  border-radius: 0;
  padding-left: 8px;
  padding-right: 8px;
  font-size: 12px;

  &:first-child {
    border-top-left-radius: ${BUTTON_BORDER_RADIUS};
    border-bottom-left-radius: ${BUTTON_BORDER_RADIUS};
  }

  &:nth-child(n + 2) {
    border-left: 0;
    border-top-right-radius: ${BUTTON_BORDER_RADIUS};
    border-bottom-right-radius: ${BUTTON_BORDER_RADIUS};
  }

  & + button {
    margin-left: 0;
  }
`;

export const TabButton = styled(SecondaryButton)`
  border-radius: 0;
  font-size: 12px;

  &:first-child {
    border-top-left-radius: ${BUTTON_BORDER_RADIUS};
    border-bottom-left-radius: ${BUTTON_BORDER_RADIUS};
  }

  &:nth-child(n + 2) {
    border-left: 0;
    border-top-right-radius: ${BUTTON_BORDER_RADIUS};
    border-bottom-right-radius: ${BUTTON_BORDER_RADIUS};
  }

  & + button {
    margin-left: 0;
  }
`;
//   ${(props: { active: boolean }): ?string =>
//     (props.active
//       ? `
//             background-color: ${colors.highlightInactive};
//             color: ${colors.white};

//             &:hover {
//                 background-color: ${colors.highlightInactive};
//                 color: ${colors.white};
//             }
//         `
//       : null)};
// `;
